export const homeTranslations = {
  en: {
    // Hero section
    'hero.title': 'Building Tomorrow Today',
    'hero.subtitle': 'FMC Construction delivers excellence in every project, from concept to completion. Your vision, our expertise, exceptional results.',
    'hero.cta': 'Get Free Quote',
    'hero.watch': 'Watch Our Story',
    
    // Badge and hero content
    'home.badge': 'Leading Construction Company Since 1998',
    'home.hero.title1': 'We Craft',
    'home.hero.title2': 'Buildings & Infrastructure',
    'home.hero.subtitle': 'We offer a complete Business Model, which starts with assistance to architects at the early stage of the projects and continues right up to project completion',
    'home.hero.cta1': 'Get Started',
    'home.hero.cta2': 'Watch Our Story',
    
    // Hero Images Content
    'hero.images.1.title': 'Precision Engineering',
    'hero.images.1.subtitle': 'in Every Build',
    'hero.images.1.description': 'We offer a complete Business Model, which starts with assistance to architects at the early stage of the projects and continues right up to project completion. Our comprehensive approach ensures every project meets the highest standards of quality, safety, and innovation.',
    'hero.images.1.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.2.title': 'Transforming Visions',
    'hero.images.2.subtitle': 'Into Reality',
    'hero.images.2.description': 'FMC Construction delivers excellence in every project, from concept to completion. Your vision, our expertise, exceptional results. We transform ambitious ideas into remarkable structures that stand the test of time.',
    'hero.images.2.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.3.title': 'Shaping the Future',
    'hero.images.3.subtitle': 'of Construction',
    'hero.images.3.description': 'With over 25 years of experience in the construction industry, we\'ve built our reputation on quality, innovation, and customer satisfaction. Our team of experts brings together decades of combined experience to deliver exceptional results that exceed expectations.',
    'hero.images.3.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.4.title': 'Uncompromising Excellence',
    'hero.images.4.subtitle': 'in Every Detail',
    'hero.images.4.description': 'Quality craftsmanship meets innovative solutions in every project we undertake. We pay meticulous attention to every detail, ensuring that our structures not only meet but exceed industry standards and client expectations.',
    'hero.images.4.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.5.title': 'Comprehensive Solutions',
    'hero.images.5.subtitle': 'for Every Challenge',
    'hero.images.5.description': 'Comprehensive construction solutions tailored to meet your specific needs and vision. From residential developments to commercial complexes, infrastructure projects to industrial facilities, we deliver excellence across all sectors.',
    'hero.images.5.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.6.title': 'Cutting-Edge Innovation',
    'hero.images.6.subtitle': 'Meets Proven Expertise',
    'hero.images.6.description': 'We embrace cutting-edge technology and innovative construction methods to deliver superior results. Our commitment to technological advancement ensures efficient, sustainable, and future-ready construction solutions.',
    'hero.images.6.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.7.title': 'Building the Foundation',
    'hero.images.7.subtitle': 'of Modern Society',
    'hero.images.7.description': 'Roads, bridges, and public works projects that serve communities and drive economic growth. We build the backbone of modern society with durable, safe, and efficient infrastructure solutions.',
    'hero.images.7.badge': 'Leading Construction Company Since 1998',
    
    'hero.images.8.title': 'Designing Environments',
    'hero.images.8.subtitle': 'That Drive Growth',
    'hero.images.8.description': 'Modern office buildings, retail spaces, and commercial facilities built with cutting-edge technology and sustainable practices. We create spaces that inspire productivity, innovation, and business success.',
    'hero.images.8.badge': 'Leading Construction Company Since 1998',
    
    // Why choose section
    'home.why.title': 'Why Choose FMC?',
    'home.why.subtitle': 'We don\'t just build structures; we build relationships, trust, and lasting value for our clients and communities.',
    'home.why.feature1.title': 'Award-Winning Quality',
    'home.why.feature1.description': 'Recognized for excellence in construction and project delivery.',
    'home.why.feature2.title': 'On-Time Delivery',
    'home.why.feature2.description': 'We value your time and ensure projects are completed as scheduled.',
    'home.why.feature3.title': 'Expert Team',
    'home.why.feature3.description': 'Skilled professionals with decades of combined experience.',
    
    // Features section
    'home.features.title': 'Why Choose',
    'home.features.subtitle': 'We combine innovation, expertise, and dedication to deliver exceptional results that exceed expectations',
    'home.features.quality.title': 'Excellence in Quality',
    'home.features.quality.description': 'We maintain the highest standards of quality and safety in all our construction projects.',
    'home.features.team.title': 'Elite Professionals',
    'home.features.team.description': 'Our team of experienced professionals ensures precision and innovation in every project.',
    'home.features.delivery.title': 'Reliable Execution',
    'home.features.delivery.description': 'We commit to delivering projects on schedule while maintaining the highest quality standards.',
    'home.features.innovation.title': 'Innovation & Technology',
    'home.features.innovation.description': 'We embrace cutting-edge technology and innovative construction methods to deliver superior results.',
    
    // Services section
    'home.services.title': 'Our',
    'home.services.highlight': 'Services',
    'home.services.subtitle': 'Comprehensive construction solutions tailored to meet your specific needs and vision',
    'home.services.learnMore': 'Learn More',
    'home.services.viewAll': 'View All Services',
    
    // Commercial services
    'home.services.commercial.title': 'Commercial Construction',
    'home.services.commercial.description': 'Modern office buildings, retail spaces, and commercial facilities built with cutting-edge technology and sustainable practices.',
    'home.services.commercial.feature1': 'Smart building systems',
    'home.services.commercial.feature2': 'Energy efficiency',
    'home.services.commercial.feature3': 'Modern aesthetics',
    'home.services.commercial.feature4': 'Timely delivery',
    
    // Residential services
    'home.services.residential.title': 'Residential Projects',
    'home.services.residential.description': 'Custom homes and residential developments that combine luxury, comfort, and innovative design.',
    'home.services.residential.feature1': 'Custom design',
    'home.services.residential.feature2': 'Premium materials',
    'home.services.residential.feature3': 'Smart home integration',
    'home.services.residential.feature4': 'Quality craftsmanship',
    
    // Infrastructure services
    'home.services.infrastructure.title': 'Infrastructure Development',
    'home.services.infrastructure.description': 'Roads, bridges, and public works projects that serve communities and drive economic growth.',
    'home.services.infrastructure.feature1': 'Durable construction',
    'home.services.infrastructure.feature2': 'Safety focused',
    'home.services.infrastructure.feature3': 'Long-term value',
    'home.services.infrastructure.feature4': 'Community impact',
    
    // Industrial services
    'home.services.industrial.title': 'Industrial Construction',
    'home.services.industrial.description': 'Heavy industrial facilities, manufacturing plants, and specialized industrial structures.',
    'home.services.industrial.feature1': 'Advanced engineering solutions',
    'home.services.industrial.feature2': 'Safety compliance',
    'home.services.industrial.feature3': 'Operational efficiency',
    'home.services.industrial.feature4': 'Scalable infrastructure',
    
    // Additional service descriptions
    'home.services.building.description': 'Complete building and infrastructure solutions from design to completion.',
    'home.services.design.description': 'Comprehensive design and engineering services for all construction projects.',
    'home.services.fitout.description': 'Professional architectural fitout and interior design services.',
    'home.services.civil.description': 'Civil engineering and infrastructure development projects.',
    'home.services.mep.description': 'Mechanical, Electrical, and Plumbing systems installation and maintenance.',
    'home.services.dataCenters.description': 'Professional data center construction and infrastructure services for modern IT facilities.',
    'home.services.pricing.description': 'Competitive pricing and bidding services for construction projects.',
    'home.services.maintenance.description': 'Comprehensive maintenance and facility management services.',
    
    // About section
    'home.about.title': 'Building the',
    'home.about.highlight': 'Future',
    'home.about.description': 'With over 25 years of experience in the construction industry, we\'ve built our reputation on quality, innovation, and customer satisfaction. Our team of experts brings together decades of combined experience to deliver exceptional results.',
    'home.about.feature1': 'State-of-the-art construction techniques',
    'home.about.feature2': 'Sustainable and eco-friendly practices',
    'home.about.feature3': 'Comprehensive project management',
    'home.about.feature4': '24/7 customer support',
    'home.about.learnMore': 'Learn More About Us',
    'home.about.excellence.title': 'Building Excellence',
    'home.about.excellence.subtitle': 'Creating structures that stand the test of time',
    
    // Service timeline section
    'home.serviceTimeline.title': 'Construction Process Timeline',
    'home.serviceTimeline.learnMore': 'Learn More',
    'home.serviceTimeline.illustration.title': 'Project Planning',
    'home.serviceTimeline.seeMore': 'See More',
    
    // Timeline steps
    'home.serviceTimeline.step1.label': 'STEP 1',
    'home.serviceTimeline.step1.title': 'Project Consultation',
    'home.serviceTimeline.step1.description': 'Initial meeting to discuss requirements and vision',
    
    'home.serviceTimeline.step2.label': 'STEP 2',
    'home.serviceTimeline.step2.title': 'Planning & Design',
    'home.serviceTimeline.step2.description': 'Detailed planning, blueprints, and project timeline',
    
    'home.serviceTimeline.step3.label': 'STEP 3',
    'home.serviceTimeline.step3.title': 'Site Preparation',
    'home.serviceTimeline.step3.description': 'Clearing, excavation, and foundation work',
    
    'home.serviceTimeline.step4.label': 'STEP 4',
    'home.serviceTimeline.step4.title': 'Construction Phase',
    'home.serviceTimeline.step4.description': 'Building structure, systems, and finishing',
    
    'home.serviceTimeline.step5.label': 'STEP 5',
    'home.serviceTimeline.step5.title': 'Quality Inspection',
    'home.serviceTimeline.step5.description': 'Final checks and quality assurance',
    
    'home.serviceTimeline.step6.label': 'STEP 6',
    'home.serviceTimeline.step6.title': 'Project Completion',
    'home.serviceTimeline.step6.description': 'Handover and final documentation',
    
    // Stats section
    'home.stats.projects': 'Projects Completed',
    'home.stats.experience': 'Years Experience',
    'home.stats.satisfaction': 'Client Satisfaction',
    
    // Showcase section
    'home.showcase.title': 'Project Showcase',
    'home.showcase.subtitle': 'Coming Soon',
    
    // Excellence section
    'home.excellence.title': 'Excellence in Every Detail',
    'home.excellence.subtitle': 'Quality craftsmanship meets innovative solutions',
    
    // Blog section
    'home.blog.title': 'Latest from Our Blog',
    'home.blog.subtitle': 'Stay updated with construction insights, industry trends, and project updates',
    'home.blog.viewArticle': 'View Article',
    'home.blog.views': 'views',
    'home.blog.readTime': 'min read',
    
    // CTA section
    'home.cta.title': 'Ready to Start Your Project?',
    'home.cta.subtitle': 'Let\'s discuss your vision and turn it into reality. Our team is ready to help you build something extraordinary.',
    'home.cta.button1': 'Get Started Today',
    'home.cta.button2': 'View Our Work',
    
    // Additional translations for hardcoded text
    'home.buttons.learnMore': 'Learn More',
    'home.buttons.exploreProjects': 'Explore Projects',
    'home.buttons.discoverMore': 'Discover more',
    'home.buttons.exploreAllIndustries': 'Explore All Industries',
    'home.buttons.viewDetails': 'View Details',
    'home.buttons.viewAllProjects': 'View All Projects',
    'home.buttons.followLinkedIn': 'Follow us on LinkedIn',
    
    // Project details labels
    'home.project.value': 'Value:',
    'home.project.location': 'Location:',
    'home.project.sector': 'Sector:',
    'home.project.year': 'Year:',
    'home.project.builtUpArea': 'Built-up Area:',
    
    // Section headings
    'home.sections.kingdomVision.title': 'Contributing to the',
    'home.sections.kingdomVision.highlight': 'Kingdom\'s Vision',
    'home.sections.companyProfile.title': 'Profile',
    'home.sections.companyProfile.highlight': 'FMC Company',
    'home.sections.featuredProjects.title': 'Our Featured',
    'home.sections.featuredProjects.highlight': 'Projects',
    'home.sections.commitmentExcellence.title': 'Our Commitment to',
    'home.sections.commitmentExcellence.highlight': 'Excellence',
    'home.sections.followLinkedIn.title': 'Follow us on',
    'home.sections.followLinkedIn.highlight': 'LinkedIn',
    
    // Company profile description
    'home.companyProfile.description': 'Discover our comprehensive company profile showcasing our expertise, projects, and commitment to excellence in construction and infrastructure development.',
    
    // Chairman quote
    'home.chairman.quote': 'The acquisition of efficiency and reliability in the construction sector doesn\'t come unless after many years of accumulation of experience and diligent work. FMC Company began in 2006 which give us pride that we were and still one of the leading companies that have contributed to the Kingdom\'s Vision 2030 through the implementation of several key projects that require attention to detail and comprehensive knowledge of the requirements of administrative planning and multiplicity resources and efficient implementation.',
    
    // Project names
    'projects.downtownOfficeComplex': 'Downtown Office Complex',
    'projects.luxuryResidentialTower': 'Luxury Residential Tower',
    'projects.highwayBridgeProject': 'Highway Bridge Project',
    'projects.shoppingMallDevelopment': 'Shopping Mall Development',
    'projects.industrialManufacturingPlant': 'Industrial Manufacturing Plant',
    'projects.healthcareFacility': 'Healthcare Facility',
    'projects.educationalCampus': 'Educational Campus',
    'projects.residentialCompound': 'Residential Compound',
    'projects.corporateHeadquarters': 'Corporate Headquarters',
    'projects.luxuryHotelResort': 'Luxury Hotel & Resort',
    'projects.metroStationDevelopment': 'Metro Station Development',
    'projects.mixedUseComplex': 'Mixed-Use Complex',
    'projects.warehouseFacility': 'Warehouse Facility',
    'projects.medicalCenter': 'Medical Center',
    'projects.universityBuilding': 'University Building',
    'projects.apartmentComplex': 'Apartment Complex',
    'projects.retailCenter': 'Retail Center',
    'projects.conferenceCenter': 'Conference Center',
    'projects.powerPlant': 'Power Plant',
    'projects.sportsComplex': 'Sports Complex',
    'projects.researchLaboratory': 'Research Laboratory',
    'projects.villaDevelopment': 'Villa Development',
    'projects.officePark': 'Office Park',
    'projects.shoppingCenter': 'Shopping Center',
    'projects.factoryComplex': 'Factory Complex',
    'projects.hospitalWing': 'Hospital Wing',
    'projects.schoolBuilding': 'School Building',
    'projects.townhouseComplex': 'Townhouse Complex',
    'projects.businessCenter': 'Business Center',
    'projects.entertainmentComplex': 'Entertainment Complex',
    'projects.refineryExtension': 'Refinery Extension',
    'projects.medicalResearchCenter': 'Medical Research Center',
    'projects.trainingInstitute': 'Training Institute',
    'projects.luxuryApartments': 'Luxury Apartments',
    'projects.financialDistrict': 'Financial District',
    'projects.culturalCenter': 'Cultural Center',
    'projects.chemicalPlant': 'Chemical Plant',
    'projects.specializedClinic': 'Specialized Clinic',
    'projects.libraryComplex': 'Library Complex',
    'projects.gardenVillas': 'Garden Villas',
    'projects.technologyPark': 'Technology Park',
    'projects.aquaticCenter': 'Aquatic Center',
    'projects.steelMill': 'Steel Mill',
    'projects.rehabilitationCenter': 'Rehabilitation Center',
    'projects.vocationalSchool': 'Vocational School',
    'projects.penthouseComplex': 'Penthouse Complex',
    'projects.innovationHub': 'Innovation Hub',
    'projects.adventurePark': 'Adventure Park',
    
    // Featured projects
    'featuredProjects.downtownOfficeComplex': 'Downtown Office Complex',
    'featuredProjects.luxuryResidentialTower': 'Luxury Residential Tower',
    'featuredProjects.highwayBridgeProject': 'Highway Bridge Project',
    'featuredProjects.shoppingMallDevelopment': 'Shopping Mall Development',
    'featuredProjects.industrialManufacturingPlant': 'Industrial Manufacturing Plant',
    'featuredProjects.healthcareFacility': 'Healthcare Facility',
    'featuredProjects.educationalCampus': 'Educational Campus',
    'featuredProjects.residentialCompound': 'Residential Compound',
    'featuredProjects.corporateHeadquarters': 'Corporate Headquarters',
    'featuredProjects.luxuryHotelResort': 'Luxury Hotel & Resort',
    'featuredProjects.metroStationDevelopment': 'Metro Station Development',
    'featuredProjects.mixedUseComplex': 'Mixed-Use Complex',
    'featuredProjects.warehouseFacility': 'Warehouse Facility',
    'featuredProjects.medicalCenter': 'Medical Center',
    'featuredProjects.universityBuilding': 'University Building',
    'featuredProjects.apartmentComplex': 'Apartment Complex',
    'featuredProjects.retailCenter': 'Retail Center',
    'featuredProjects.conferenceCenter': 'Conference Center',
    'featuredProjects.sportsComplex': 'Sports Complex',
    'featuredProjects.researchFacility': 'Research Facility',
    'featuredProjects.entertainmentComplex': 'Entertainment Complex',
    'featuredProjects.logisticsHub': 'Logistics Hub',
    'featuredProjects.culturalCenter': 'Cultural Center',
    'featuredProjects.officeTower': 'Office Tower',
    'featuredProjects.residentialTower': 'Residential Tower',
    'featuredProjects.shoppingCenter': 'Shopping Center',
    'featuredProjects.hotelComplex': 'Hotel Complex',
    'featuredProjects.medicalComplex': 'Medical Complex',
    'featuredProjects.educationalComplex': 'Educational Complex',
    'featuredProjects.industrialComplex': 'Industrial Complex',
    'featuredProjects.commercialComplex': 'Commercial Complex',
    'featuredProjects.residentialDevelopment': 'Residential Development',
    'featuredProjects.commercialDevelopment': 'Commercial Development',
    'featuredProjects.industrialDevelopment': 'Industrial Development',
    'featuredProjects.infrastructureDevelopment': 'Infrastructure Development',
    'featuredProjects.healthcareDevelopment': 'Healthcare Development',
    'featuredProjects.educationalDevelopment': 'Educational Development',
    'featuredProjects.hospitalityDevelopment': 'Hospitality Development',
    'featuredProjects.recreationalDevelopment': 'Recreational Development',
    'featuredProjects.mixedUseDevelopment': 'Mixed-Use Development',
    'featuredProjects.urbanDevelopment': 'Urban Development',
    'featuredProjects.smartCity': 'Smart City',
    'featuredProjects.ecoFriendlyBuilding': 'Eco-Friendly Building',
    'featuredProjects.sustainableDevelopment': 'Sustainable Development',
    'featuredProjects.greenBuilding': 'Green Building',
    'featuredProjects.modernFacility': 'Modern Facility',
    'featuredProjects.stateOfTheArt': 'State-of-the-Art Facility',
    'featuredProjects.adventurePark': 'Adventure Park',
    'featuredProjects.powerPlant': 'Power Plant',
    'featuredProjects.villaDevelopment': 'Villa Development',
    'featuredProjects.officePark': 'Office Park',
    'featuredProjects.factoryComplex': 'Factory Complex',
    'featuredProjects.hospitalWing': 'Hospital Wing',
    'featuredProjects.schoolBuilding': 'School Building',
    'featuredProjects.townhouseComplex': 'Townhouse Complex',
    'featuredProjects.businessCenter': 'Business Center',
    'featuredProjects.refineryExtension': 'Refinery Extension',
    'featuredProjects.medicalResearchCenter': 'Medical Research Center',
    'featuredProjects.trainingInstitute': 'Training Institute',
    'featuredProjects.luxuryApartments': 'Luxury Apartments',
    'featuredProjects.financialDistrict': 'Financial District',
    'featuredProjects.chemicalPlant': 'Chemical Plant',
    'featuredProjects.specializedClinic': 'Specialized Clinic',
    'featuredProjects.libraryComplex': 'Library Complex',
    'featuredProjects.gardenVillas': 'Garden Villas',
    'featuredProjects.technologyPark': 'Technology Park',
    'featuredProjects.aquaticCenter': 'Aquatic Center',
    'featuredProjects.steelMill': 'Steel Mill',
    'featuredProjects.rehabilitationCenter': 'Rehabilitation Center',
    'featuredProjects.vocationalSchool': 'Vocational School',
    'featuredProjects.penthouseComplex': 'Penthouse Complex',
    'featuredProjects.innovationHub': 'Innovation Hub',
    
    // Project sectors
    'sectors.commercial': 'Commercial',
    'sectors.residential': 'Residential',
    'sectors.infrastructure': 'Infrastructure',
    'sectors.industrial': 'Industrial',
    'sectors.healthcare': 'Healthcare',
    'sectors.educational': 'Educational',
    'sectors.hospitality': 'Hospitality',
    'sectors.mixedUse': 'Mixed-Use',
    'sectors.recreational': 'Recreational',
    
    // Project status
    'status.completed': 'Completed',
    'status.ongoing': 'Ongoing',
  },
  ar: {
    // Hero section
    'hero.title': 'نبني الغد اليوم',
    'hero.subtitle': 'تقدم شركة إف إم سي للبناء التميز في كل مشروع، من الفكرة إلى الإنجاز. رؤيتك، خبرتنا، نتائج استثنائية.',
    'hero.cta': 'احصل على عرض سعر مجاني',
    'hero.watch': 'شاهد قصتنا',
    
    // Badge and hero content
    'home.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    'home.hero.title1': 'نحن نصمم',
    'home.hero.title2': 'المباني والبنية التحتية',
    'home.hero.subtitle': 'نقدم نموذج عمل متكاملاً، يبدأ بمساعدة المهندسين المعماريين في المراحل المبكرة من المشاريع ويستمر حتى إنجاز المشروع',
    'home.hero.cta1': 'ابدأ الآن',
    'home.hero.cta2': 'شاهد قصتنا',
    
    // Hero Images Content
    'hero.images.1.title': 'الهندسة الدقيقة',
    'hero.images.1.subtitle': 'في كل بناء',
    'hero.images.1.description': 'نقدم نموذج عمل متكاملاً، يبدأ بمساعدة المهندسين المعماريين في المراحل المبكرة من المشاريع ويستمر حتى إنجاز المشروع. نهجنا الشامل يضمن أن كل مشروع يلبي أعلى معايير الجودة والسلامة والابتكار.',
    'hero.images.1.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.2.title': 'تحويل الرؤى',
    'hero.images.2.subtitle': 'إلى واقع ملموس',
    'hero.images.2.description': 'تقدم شركة إف إم سي للبناء التميز في كل مشروع، من الفكرة إلى الإنجاز. رؤيتك، خبرتنا، نتائج استثنائية. نحول الأفكار الطموحة إلى هياكل رائعة تصمد أمام اختبار الزمن.',
    'hero.images.2.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.3.title': 'تشكيل مستقبل',
    'hero.images.3.subtitle': 'صناعة البناء',
    'hero.images.3.description': 'مع أكثر من ٢٥ عاماً من الخبرة في صناعة البناء، بنينا سمعتنا على الجودة والابتكار ورضا العملاء. يجمع فريقنا من الخبراء عقود من الخبرة المجمعة لتقديم نتائج استثنائية تتجاوز التوقعات.',
    'hero.images.3.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.4.title': 'التميز الذي لا يتزعزع',
    'hero.images.4.subtitle': 'في كل التفاصيل',
    'hero.images.4.description': 'الحرفية عالية الجودة تلتقي بالحلول المبتكرة في كل مشروع نقوم به. نولي اهتماماً دقيقاً لكل تفصيل، مما يضمن أن هياكلنا لا تلبي فحسب بل تتجاوز معايير الصناعة وتوقعات العملاء.',
    'hero.images.4.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.5.title': 'حلول شاملة',
    'hero.images.5.subtitle': 'لكل التحديات',
    'hero.images.5.description': 'حلول بناء شاملة مصممة لتلبية احتياجاتك ورؤيتك المحددة. من التطويرات السكنية إلى المجمعات التجارية، مشاريع البنية التحتية إلى المرافق الصناعية، نقدم التميز عبر جميع القطاعات.',
    'hero.images.5.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.6.title': 'الابتكار المتقدم',
    'hero.images.6.subtitle': 'يلتقي بالخبرة المثبتة',
    'hero.images.6.description': 'نتبنى أحدث التقنيات وطرق البناء المبتكرة لتقديم نتائج متفوقة. التزامنا بالتقدم التكنولوجي يضمن حلول بناء فعالة ومستدامة وجاهزة للمستقبل.',
    'hero.images.6.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.7.title': 'بناء الأساس',
    'hero.images.7.subtitle': 'للمجتمع الحديث',
    'hero.images.7.description': 'طرق وجسور ومشاريع أعمال عامة تخدم المجتمعات وتدفع النمو الاقتصادي. نبني العمود الفقري للمجتمع الحديث بحلول بنية تحتية متينة وآمنة وفعالة.',
    'hero.images.7.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    'hero.images.8.title': 'تصميم بيئات',
    'hero.images.8.subtitle': 'تدفع النمو',
    'hero.images.8.description': 'مباني مكتبية حديثة ومساحات تجارية ومرافق تجارية مبنية بأحدث التقنيات والممارسات المستدامة. نخلق مساحات تلهم الإنتاجية والابتكار ونجاح الأعمال.',
    'hero.images.8.badge': 'شركة البناء الرائدة منذ ١٩٩٨',
    
    // Why choose section
    'home.why.title': 'لماذا تختار إف إم سي؟',
    'home.why.subtitle': 'نحن لا نبني الهياكل فحسب؛ بل نبني العلاقات والثقة والقيمة الدائمة لعملائنا ومجتمعاتنا.',
    'home.why.feature1.title': 'جودة حائزة على جوائز',
    'home.why.feature1.description': 'معترف بنا للتميز في البناء وتسليم المشاريع.',
    'home.why.feature2.title': 'تسليم في الوقت المحدد',
    'home.why.feature2.description': 'نقدر وقتك ونتأكد من إنجاز المشاريع كما هو مجدول.',
    'home.why.feature3.title': 'فريق خبير',
    'home.why.feature3.description': 'محترفون مهرة مع عقود من الخبرة المجمعة.',
    
    // Features section
    'home.features.title': 'لماذا تختار',
    'home.features.subtitle': 'نجمع بين الابتكار والخبرة والتفاني لتقديم نتائج استثنائية تتجاوز التوقعات',
    'home.features.quality.title': 'التميز في الجودة',
    'home.features.quality.description': 'نحافظ على أعلى معايير الجودة والسلامة في جميع مشاريع البناء.',
    'home.features.team.title': 'محترفون نخبة',
    'home.features.team.description': 'فريقنا من المحترفين ذوي الخبرة يضمن الدقة والابتكار في كل مشروع.',
    'home.features.delivery.title': 'تنفيذ موثوق',
    'home.features.delivery.description': 'نلتزم بتسليم المشاريع في الجدول الزمني مع الحفاظ على أعلى معايير الجودة.',
    'home.features.innovation.title': 'الابتكار والتكنولوجيا',
    'home.features.innovation.description': 'نتبنى أحدث التقنيات وطرق البناء المبتكرة لتقديم نتائج متفوقة.',
    
    // Services section
    'home.services.title': 'تعرف على',
    'home.services.highlight': 'خدماتنا',
    'home.services.subtitle': 'حلول بناء شاملة مصممة لتلبية احتياجاتك ورؤيتك المحددة',
    'home.services.learnMore': 'اعرف المزيد',
    'home.services.viewAll': 'عرض جميع الخدمات',
    
    // Commercial services
    'home.services.commercial.title': 'البناء التجاري',
    'home.services.commercial.description': 'مباني مكتبية حديثة ومساحات تجارية ومرافق تجارية مبنية بأحدث التقنيات والممارسات المستدامة.',
    'home.services.commercial.feature1': 'أنظمة المباني الذكية',
    'home.services.commercial.feature2': 'كفاءة الطاقة',
    'home.services.commercial.feature3': 'جماليات حديثة',
    'home.services.commercial.feature4': 'تسليم في الوقت المحدد',
    
    // Residential services
    'home.services.residential.title': 'المشاريع السكنية',
    'home.services.residential.description': 'منازل مخصصة وتطويرات سكنية تجمع بين الفخامة والراحة والتصميم المبتكر.',
    'home.services.residential.feature1': 'تصميم مخصص',
    'home.services.residential.feature2': 'مواد عالية الجودة',
    'home.services.residential.feature3': 'تكامل المنزل الذكي',
    'home.services.residential.feature4': 'حرفية عالية الجودة',
    
    // Infrastructure services
    'home.services.infrastructure.title': 'تطوير البنية التحتية',
    'home.services.infrastructure.description': 'طرق وجسور ومشاريع أعمال عامة تخدم المجتمعات وتدفع النمو الاقتصادي.',
    'home.services.infrastructure.feature1': 'بناء متين',
    'home.services.infrastructure.feature2': 'مركز على السلامة',
    'home.services.infrastructure.feature3': 'قيمة طويلة المدى',
    'home.services.infrastructure.feature4': 'تأثير على المجتمع',
    
    // Industrial services
    'home.services.industrial.title': 'البناء الصناعي',
    'home.services.industrial.description': 'مرافق صناعية ثقيلة ومصانع تصنيع وهياكل صناعية متخصصة.',
    'home.services.industrial.feature1': 'حلول هندسية متقدمة',
    'home.services.industrial.feature2': 'امتثال السلامة',
    'home.services.industrial.feature3': 'كفاءة تشغيلية',
    'home.services.industrial.feature4': 'بنية تحتية قابلة للتوسع',
    
    // Additional service descriptions
    'home.services.building.description': 'حلول بناء وبنية تحتية متكاملة من التصميم إلى الإنجاز.',
    'home.services.design.description': 'خدمات تصميم وهندسة شاملة لجميع مشاريع البناء.',
    'home.services.fitout.description': 'خدمات تشطيب معماري وتصميم داخلي احترافية.',
    'home.services.civil.description': 'مشاريع الهندسة المدنية وتطوير البنية التحتية.',
    'home.services.mep.description': 'تركيب وصيانة أنظمة الميكانيكية والكهربائية والسباكة.',
    'home.services.dataCenters.description': 'خدمات بناء مراكز البيانات والبنية التحتية الاحترافية لمرافق تكنولوجيا المعلومات الحديثة.',
    'home.services.pricing.description': 'خدمات تسعير وتقديم عطاءات تنافسية لمشاريع البناء.',
    'home.services.maintenance.description': 'خدمات صيانة وإدارة مرافق شاملة.',
    
    // About section
    'home.about.title': 'نبني',
    'home.about.highlight': 'المستقبل',
    'home.about.description': 'مع أكثر من ٢٥ عاماً من الخبرة في صناعة البناء، بنينا سمعتنا على الجودة والابتكار ورضا العملاء. يجمع فريقنا من الخبراء عقود من الخبرة المجمعة لتقديم نتائج استثنائية.',
    'home.about.feature1': 'تقنيات بناء حديثة',
    'home.about.feature2': 'ممارسات مستدامة وصديقة للبيئة',
    'home.about.feature3': 'إدارة مشاريع شاملة',
    'home.about.feature4': 'دعم العملاء على مدار الساعة',
    'home.about.learnMore': 'اعرف المزيد عنا',
    'home.about.excellence.title': 'بناء التميز',
    'home.about.excellence.subtitle': 'إنشاء هياكل تصمد أمام اختبار الزمن',
    
    // Service timeline section
    'home.serviceTimeline.title': 'الجدول الزمني لعملية البناء',
    'home.serviceTimeline.learnMore': 'اعرف المزيد',
    'home.serviceTimeline.illustration.title': 'تخطيط المشروع',
    'home.serviceTimeline.seeMore': 'شاهد المزيد',
    
    // Timeline steps
    'home.serviceTimeline.step1.label': 'الخطوة ١',
    'home.serviceTimeline.step1.title': 'استشارة المشروع',
    'home.serviceTimeline.step1.description': 'اجتماع أولي لمناقشة المتطلبات والرؤية',
    
    'home.serviceTimeline.step2.label': 'الخطوة ٢',
    'home.serviceTimeline.step2.title': 'التخطيط والتصميم',
    'home.serviceTimeline.step2.description': 'تخطيط مفصل ومخططات وجدول زمني للمشروع',
    
    'home.serviceTimeline.step3.label': 'الخطوة ٣',
    'home.serviceTimeline.step3.title': 'إعداد الموقع',
    'home.serviceTimeline.step3.description': 'تنظيف وحفر وأعمال الأساس',
    
    'home.serviceTimeline.step4.label': 'الخطوة ٤',
    'home.serviceTimeline.step4.title': 'مرحلة البناء',
    'home.serviceTimeline.step4.description': 'بناء الهيكل والأنظمة والتشطيب',
    
    'home.serviceTimeline.step5.label': 'الخطوة ٥',
    'home.serviceTimeline.step5.title': 'فحص الجودة',
    'home.serviceTimeline.step5.description': 'فحوصات نهائية وضمان الجودة',
    
    'home.serviceTimeline.step6.label': 'الخطوة ٦',
    'home.serviceTimeline.step6.title': 'إنجاز المشروع',
    'home.serviceTimeline.step6.description': 'تسليم والتوثيق النهائي',
    
    // Stats section
    'home.stats.projects': 'مشاريع مكتملة',
    'home.stats.experience': 'سنوات الخبرة',
    'home.stats.satisfaction': 'رضا العملاء',
    
    // Showcase section
    'home.showcase.title': 'عرض المشاريع',
    'home.showcase.subtitle': 'قريباً',
    
    // Excellence section
    'home.excellence.title': 'التميز في كل التفاصيل',
    'home.excellence.subtitle': 'الحرفية عالية الجودة تلتقي بالحلول المبتكرة',
    
    // Blog section
    'home.blog.title': 'أحدث من مدونتنا',
    'home.blog.subtitle': 'ابق على اطلاع برؤى البناء والاتجاهات الصناعية وتحديثات المشاريع',
    'home.blog.viewArticle': 'عرض المقال',
    'home.blog.views': 'مشاهدات',
    'home.blog.readTime': 'دقائق للقراءة',
    
    // CTA section
    'home.cta.title': 'مستعد لبدء مشروعك؟',
    'home.cta.subtitle': 'دعنا نناقش رؤيتك ونحولها إلى واقع. فريقنا مستعد لمساعدتك في بناء شيء استثنائي.',
    'home.cta.button1': 'ابدأ اليوم',
    'home.cta.button2': 'شاهد أعمالنا',
    
    // Additional translations for hardcoded text
    'home.buttons.learnMore': 'اعرف المزيد',
    'home.buttons.exploreProjects': 'استكشف المشاريع',
    'home.buttons.discoverMore': 'اكتشف المزيد',
    'home.buttons.exploreAllIndustries': 'استكشف جميع الصناعات',
    'home.buttons.viewDetails': 'عرض التفاصيل',
    'home.buttons.viewAllProjects': 'عرض جميع المشاريع',
    'home.buttons.followLinkedIn': 'تابعنا على لينكد إن',
    
    // Project details labels
    'home.project.value': 'القيمة:',
    'home.project.location': 'الموقع:',
    'home.project.sector': 'القطاع:',
    'home.project.year': 'السنة:',
    'home.project.builtUpArea': 'المساحة المبنية:',
    
    // Section headings
    'home.sections.kingdomVision.title': 'المساهمة في',
    'home.sections.kingdomVision.highlight': 'رؤية المملكة',
    'home.sections.companyProfile.title': 'ملف شركة',
    'home.sections.companyProfile.highlight': 'FMC',
    'home.sections.featuredProjects.title': 'مشاريعنا',
    'home.sections.featuredProjects.highlight': 'المميزة',
    'home.sections.commitmentExcellence.title': 'التزامنا',
    'home.sections.commitmentExcellence.highlight': 'بالتميز',
    'home.sections.followLinkedIn.title': 'تابعنا على',
    'home.sections.followLinkedIn.highlight': 'لينكد إن',
    
    // Company profile description
    'home.companyProfile.description': 'اكتشف ملف الشركة الشامل الذي يعرض خبرتنا ومشاريعنا والتزامنا بالتميز في البناء وتطوير البنية التحتية.',
    
    // Chairman quote
    'home.chairman.quote': 'لا تأتي كفاءة وموثوقية قطاع البناء إلا بعد سنوات عديدة من تراكم الخبرة والعمل الدؤوب. بدأت شركة إف إم سي في عام ٢٠٠٦ مما يجعلنا فخورين بأننا كنا ولا نزال من الشركات الرائدة التي ساهمت في رؤية المملكة 2030 من خلال تنفيذ عدة مشاريع رئيسية تتطلب الاهتمام بالتفاصيل والمعرفة الشاملة لمتطلبات التخطيط الإداري وتعدد الموارد والتنفيذ الفعال.',
    
    // Project names
    'projects.downtownOfficeComplex': 'مجمع المكاتب في وسط المدينة',
    'projects.luxuryResidentialTower': 'برج سكني فاخر',
    'projects.highwayBridgeProject': 'مشروع جسر الطريق السريع',
    'projects.shoppingMallDevelopment': 'تطوير مجمع تجاري',
    'projects.industrialManufacturingPlant': 'مصنع صناعي',
    'projects.healthcareFacility': 'مركز رعاية صحية',
    'projects.educationalCampus': 'حرم تعليمي',
    'projects.residentialCompound': 'مجمع سكني',
    'projects.corporateHeadquarters': 'المقر الرئيسي للشركة',
    'projects.luxuryHotelResort': 'فندق ومنتجع فاخر',
    'projects.metroStationDevelopment': 'تطوير محطة مترو',
    'projects.mixedUseComplex': 'مجمع متعدد الاستخدامات',
    'projects.warehouseFacility': 'مرافق مستودعات',
    'projects.medicalCenter': 'مركز طبي',
    'projects.universityBuilding': 'مبنى جامعي',
    'projects.apartmentComplex': 'مجمع شقق',
    'projects.retailCenter': 'مركز تجاري',
    'projects.conferenceCenter': 'مركز مؤتمرات',
    'projects.powerPlant': 'محطة طاقة',
    'projects.sportsComplex': 'مجمع رياضي',
    'projects.researchLaboratory': 'مختبر أبحاث',
    'projects.villaDevelopment': 'تطوير فيلات',
    'projects.officePark': 'حديقة مكاتب',
    'projects.shoppingCenter': 'مركز تسوق',
    'projects.factoryComplex': 'مجمع مصانع',
    'projects.hospitalWing': 'جناح مستشفى',
    'projects.schoolBuilding': 'مبنى مدرسة',
    'projects.townhouseComplex': 'مجمع منازل متلاصقة',
    'projects.businessCenter': 'مركز أعمال',
    'projects.entertainmentComplex': 'مجمع ترفيهي',
    'projects.refineryExtension': 'توسعة مصفاة',
    'projects.medicalResearchCenter': 'مركز أبحاث طبية',
    'projects.trainingInstitute': 'معهد تدريبي',
    'projects.luxuryApartments': 'شقق فاخرة',
    'projects.financialDistrict': 'المنطقة المالية',
    'projects.culturalCenter': 'مركز ثقافي',
    'projects.chemicalPlant': 'مصنع كيميائي',
    'projects.specializedClinic': 'عيادة متخصصة',
    'projects.libraryComplex': 'مجمع مكتبات',
    'projects.gardenVillas': 'فيلات حدائق',
    'projects.technologyPark': 'حديقة تكنولوجيا',
    'projects.aquaticCenter': 'مركز مائي',
    'projects.steelMill': 'مصنع حديد',
    'projects.rehabilitationCenter': 'مركز تأهيل',
    'projects.vocationalSchool': 'مدرسة مهنية',
    'projects.penthouseComplex': 'مجمع بنتهاوس',
    'projects.innovationHub': 'مركز ابتكار',
    'projects.adventurePark': 'حديقة مغامرات',
    
    // Featured projects
    'featuredProjects.downtownOfficeComplex': 'مجمع المكاتب في وسط المدينة',
    'featuredProjects.luxuryResidentialTower': 'برج سكني فاخر',
    'featuredProjects.highwayBridgeProject': 'مشروع جسر الطريق السريع',
    'featuredProjects.shoppingMallDevelopment': 'تطوير مجمع تجاري',
    'featuredProjects.industrialManufacturingPlant': 'مصنع صناعي للتصنيع',
    'featuredProjects.healthcareFacility': 'مركز رعاية صحية',
    'featuredProjects.educationalCampus': 'حرم تعليمي',
    'featuredProjects.residentialCompound': 'مجمع سكني',
    'featuredProjects.corporateHeadquarters': 'المقر الرئيسي للشركة',
    'featuredProjects.luxuryHotelResort': 'فندق ومنتجع فاخر',
    'featuredProjects.metroStationDevelopment': 'تطوير محطة مترو',
    'featuredProjects.mixedUseComplex': 'مجمع متعدد الاستخدامات',
    'featuredProjects.warehouseFacility': 'مركز مستودعات',
    'featuredProjects.medicalCenter': 'مركز طبي',
    'featuredProjects.universityBuilding': 'مبنى جامعي',
    'featuredProjects.apartmentComplex': 'مجمع شقق',
    'featuredProjects.retailCenter': 'مركز تجاري',
    'featuredProjects.conferenceCenter': 'مركز مؤتمرات',
    'featuredProjects.sportsComplex': 'مجمع رياضي',
    'featuredProjects.researchFacility': 'مركز أبحاث',
    'featuredProjects.entertainmentComplex': 'مجمع ترفيهي',
    'featuredProjects.logisticsHub': 'مركز لوجستي',
    'featuredProjects.culturalCenter': 'مركز ثقافي',
    'featuredProjects.officeTower': 'برج مكاتب',
    'featuredProjects.residentialTower': 'برج سكني',
    'featuredProjects.shoppingCenter': 'مركز تسوق',
    'featuredProjects.hotelComplex': 'مجمع فنادق',
    'featuredProjects.medicalComplex': 'مجمع طبي',
    'featuredProjects.educationalComplex': 'مجمع تعليمي',
    'featuredProjects.industrialComplex': 'مجمع صناعي',
    'featuredProjects.commercialComplex': 'مجمع تجاري',
    'featuredProjects.residentialDevelopment': 'تطوير سكني',
    'featuredProjects.commercialDevelopment': 'تطوير تجاري',
    'featuredProjects.industrialDevelopment': 'تطوير صناعي',
    'featuredProjects.infrastructureDevelopment': 'تطوير البنية التحتية',
    'featuredProjects.healthcareDevelopment': 'تطوير الرعاية الصحية',
    'featuredProjects.educationalDevelopment': 'تطوير تعليمي',
    'featuredProjects.hospitalityDevelopment': 'تطوير فندقي',
    'featuredProjects.recreationalDevelopment': 'تطوير ترفيهي',
    'featuredProjects.mixedUseDevelopment': 'تطوير متعدد الاستخدامات',
    'featuredProjects.urbanDevelopment': 'تطوير حضري',
    'featuredProjects.smartCity': 'مدينة ذكية',
    'featuredProjects.ecoFriendlyBuilding': 'مبنى صديق للبيئة',
    'featuredProjects.sustainableDevelopment': 'تطوير مستدام',
    'featuredProjects.greenBuilding': 'مبنى أخضر',
    'featuredProjects.modernFacility': 'مركز حديث',
    'featuredProjects.stateOfTheArt': 'مركز متطور',
    'featuredProjects.adventurePark': 'حديقة مغامرات',
    'featuredProjects.powerPlant': 'محطة طاقة',
    'featuredProjects.villaDevelopment': 'تطوير فيلات',
    'featuredProjects.officePark': 'حديقة مكاتب',
    'featuredProjects.factoryComplex': 'مجمع مصانع',
    'featuredProjects.hospitalWing': 'جناح مستشفى',
    'featuredProjects.schoolBuilding': 'مبنى مدرسة',
    'featuredProjects.townhouseComplex': 'مجمع منازل متلاصقة',
    'featuredProjects.businessCenter': 'مركز أعمال',
    'featuredProjects.refineryExtension': 'توسعة مصفاة',
    'featuredProjects.medicalResearchCenter': 'مركز أبحاث طبية',
    'featuredProjects.trainingInstitute': 'معهد تدريب',
    'featuredProjects.luxuryApartments': 'شقق فاخرة',
    'featuredProjects.financialDistrict': 'منطقة مالية',
    'featuredProjects.chemicalPlant': 'مصنع كيماويات',
    'featuredProjects.specializedClinic': 'عيادة متخصصة',
    'featuredProjects.libraryComplex': 'مجمع مكتبات',
    'featuredProjects.gardenVillas': 'فيلات حدائق',
    'featuredProjects.technologyPark': 'حديقة تكنولوجيا',
    'featuredProjects.aquaticCenter': 'مركز مائي',
    'featuredProjects.steelMill': 'مصنع حديد',
    'featuredProjects.rehabilitationCenter': 'مركز تأهيل',
    'featuredProjects.vocationalSchool': 'مدرسة مهنية',
    'featuredProjects.penthouseComplex': 'مجمع بنتهاوس',
    'featuredProjects.innovationHub': 'مركز ابتكار',
    
    // Project sectors
    'sectors.commercial': 'تجاري',
    'sectors.residential': 'سكني',
    'sectors.infrastructure': 'بنية تحتية',
    'sectors.industrial': 'صناعي',
    'sectors.healthcare': 'رعاية صحية',
    'sectors.educational': 'تعليمي',
    'sectors.hospitality': 'فندقي',
    'sectors.mixedUse': 'متعدد الاستخدامات',
    'sectors.recreational': 'ترفيهي',
    
    // Project status
    'status.completed': 'مكتمل',
    'status.ongoing': 'جاري',
  }
};
